import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { UserProps } from "../../interfaces/pacientes.interface";
import history from "../../routes/history";
import { TypesErrorRequest } from "../../utils/types";
import { AppActions } from "../ducks/app";
import { ConfigsActions } from "../ducks/configs";
import { FinancialActions, Types } from "../ducks/financial";
import * as Sentry from "@sentry/react";
import { TextsProps } from "../../database/txt.interface";
import { FaturaProps } from "../../interfaces/cartao.interface";
import { DashBoardActions } from "../ducks/dashboard";
import { whiteListProps } from "../../pages/MenueConta/Pagamentos/ModalBoleto";
import { sendErrorSentryOrLocalHost } from "../../utils/funcs";

function* addCard({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	const config_servicos = yield select(
		(state: any) => state.configs.config_servicos
	);
	const type_client: 'bank_slip_pix' | 'card' | null = yield select((state: any) => state.financial.type_client);
	const faturas: FaturaProps[] = yield select((state: any) => state.financial.faturas);

	async function apiCall() {
		try {
			const dataRequest = {
				...payload,
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dataRequest),
			};
			const res = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}financeiro/alterar_cartao`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao adicionar cartão - addcard',
				tags: {
					endpoint: '/financeiro/alterar_cartao',
					file: 'src/store/sagas/financial.ts' 
				},
			})
			throw e;
		}
	}

	try {

		const data = yield call(apiCall);

		if (data.status == TypesErrorRequest.FAIL) {

			yield put(FinancialActions.set_payment_error_with_card(true))
			yield put(FinancialActions.set_modal_falha_pagamento(true, data?.code.toString()))
		} else if (data.status == TypesErrorRequest.SUCCESS) {

			yield put(FinancialActions.set_change_type_form_payment('card'));
			yield put(FinancialActions.financial_request(
				config_servicos?.SERVICO_IUGU,
				config_servicos?.SERVICO_SUPERLOGICA
			))
			if(type_client === 'bank_slip_pix'){
				yield put(FinancialActions.set_change_type_form_payment('card'))
				yield put(FinancialActions.alterar_forma_pagamento_request({
					SERVICO_SUPERLOGICA: String(config_servicos?.SERVICO_SUPERLOGICA),
					FORMA_PAGAMENTO: 'bank_slip',
					FATURAS: [faturas?.[faturas.length -1]?.ID_FATURA]
				}))
			}

		} else if (data.message) {

			if (data.message === "Bad Request") {
				const message = current_language?.falha_salvar_cartao;
				yield put(AppActions.showSnackbar(message, "error"));
			}

		}
	} catch (e) {
	} finally {
		yield put(FinancialActions.add_card_cancel());
	}
}

function* getFaturas({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const paymentSuccess:boolean = yield select((state) => state.financial.payment_executed,)
	async function apiCall() {
		try {
			const dataRequest = {
				SERVICO_IUGU: payload?.SERVICO_IUGU,
				SERVICO_SUPERLOGICA: payload?.SERVICO_SUPERLOGICA,
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dataRequest),
			};
			const res = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}financeiro/faturas_cartoes`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar faturas - getFaturas',
				tags: {
					endpoint: '/financeiro/faturas_cartoes',
					file: 'src/store/sagas/financial.ts' 
				},
			})
			throw e;
		}
	}
	async function saveTypeClientInLocalStorage(data:string) {

		const typeClientLocalStorage = localStorage.getItem('TypeClientFinancial')

		if(!typeClientLocalStorage){
			 localStorage.setItem("TypeClientFinancial", data)
		}else{
			localStorage.removeItem('TypeClientFinancial')
			localStorage.setItem("TypeClientFinancial", data)
		}
	}

	try {
		const data = yield call(apiCall);
		if (data.status === TypesErrorRequest.SUCCESS) {

			if(data?.tipo_cliente){	saveTypeClientInLocalStorage(data?.tipo_cliente)	}
			yield put(FinancialActions.set_type_client(data?.tipo_cliente));
			yield put(
				FinancialActions.financial_request_sucess(
					data.dados_cartoes,
					data.dados_faturas
				)
			);
			yield put(
				FinancialActions.set_info_cartao_faltando(data?.cartao_faltando)
			);
			if(paymentSuccess){
				yield put(FinancialActions.set_modal_pagamento_realizado(true))
				yield put(FinancialActions.set_load_card(false))
				// yield put(AppActions.set_card_registration_shortcut(false))
			}
			yield put(FinancialActions.set_last_data_white_list(data?.ultima_resposta_whitelist));
			yield put(FinancialActions.set_payment_executed(false))
		}
	} catch (e) {
		yield put(FinancialActions.financial_request_failed());
	} finally {
		yield put(FinancialActions.financial_request_failed());
	}
}

function* getPlanosItens({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	yield put(FinancialActions.set_loading_upsell(true));
	async function apiCall() {
		try {
			const dat = {
				TOKEN: user_logado.token,
			};
			const requestOptionsPlano: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dat),
			};
			const resPlano = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/planos`,
				requestOptionsPlano
			);
			const response_plano: any = await resPlano.json();

			const requestOptionsItem: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dat),
			};
			const resItem = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/planos`,
				requestOptionsItem
			);
			const response_item: any = await resItem.json();
			return { response_plano, response_item };
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar planos - getPlanosItens',
				tags: {
					endpoint: '/syncs/iten',
					file: 'src/store/sagas/financial.ts' 
				},
				payload: payload
			})
			throw e;
		}
	}

	try {
		const data = yield call(apiCall);

		yield put(FinancialActions.set_plano_upsell(data.response_plano));
		yield put(FinancialActions.set_item_upsell(data.response_item));
	} catch (e) {
	} finally {
		yield put(FinancialActions.set_loading_upsell(false));
	}
}

function* assinarPlano({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	yield put(FinancialActions.set_loading_upsell(true));
	async function apiCall() {
		try {
			const dat = {
				TOKEN: user_logado.token,
				...payload,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dat),
			};
			const res = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}financeiro/alterar_plano`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao assinar planos - assinarPlano',
				tags: {
					endpoint: 'financeiro/alterar_plano',
					file: 'src/store/sagas/financial.ts' 
				},
				payload: payload
			})
		
			throw e;
		}
	}

	try {
		const data = yield call(apiCall);
		if (data.status == TypesErrorRequest.SUCCESS) {
			let message: any = "";

			message = current_language?.assinatura_atualizada;

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: message,
				})
			);
		} else {
			let message: any = "";

			message = current_language?.erro_iugu;

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: message,
				})
			);
		}
	} catch (e) {
	} finally {
		yield put(ConfigsActions.config_request());
	}
}

function* assinarItem({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	yield put(FinancialActions.set_loading_upsell(true));
	async function apiCall() {
		try {
			const dat = {
				TOKEN: user_logado.token,
				...payload,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(dat),
			};
			const res = await fetch(
				`${process.env.REACT_APP_BASE_URL_V7}financeiro/adicionar_item`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao assinar item - assinarItem',
				tags: {
					endpoint: 'financeiro/adicionar_item',
					file: 'src/store/sagas/financial.ts' 
				},
				payload: payload
			})
			
			throw e;
		}
	}

	try {
		const data = yield call(apiCall);
		if (data.status == TypesErrorRequest.SUCCESS) {
			let message: any = "";

			message = current_language?.assinatura_atualizada;

			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: message,
				})
			);
		} else {
			let message: any = "";
			if (data.code === 1) {
				message = current_language?.erro_iugu;
			}
			if (data.code === 2) {
				message = current_language?.menu_lateral_fatura_pendente;
			}
			if (data.code === 3) {
				message = current_language?.assinatura_nao_encontrada;
			}
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: message,
				})
			);
		}
	} catch (e) {
	} finally {
		yield put(ConfigsActions.config_request());
		history.push("/upgrade");
	}
}

function* alterarFormaPagamento({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const current_language: any = yield select(
		(state) => state.configs.current_language
	);
	const modalSelectFormPayment = yield select(	(state: any) => state.financial.modal_escolha_forma_pagamento);
	const payment_type: 'bank_slip' | 'pix' | 'card' | null = yield select((state: any) => state.financial.payment_type);
	const inadimplencia_motivo = yield select((state: any) => state.configs.config_inadimplencia?.INADIMPLENCIA_MOTIVO)
	const modaErrorPixVisible = yield select(	(state: any) => state.financial.moda_error_pix_data);

	async function apiCall() {
		try {
			const dataRequest = {
				...payload,
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				body: JSON.stringify(dataRequest),
			};
			// const res = await fetch(
			// 	`${process.env.REACT_APP_BASE_URL}financeiro/financeiro_alterar_forma_pagamento.php`,
			// 	requestOptions
			// );
			// const response: any = await res.json();
			// return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao alterar forma de pagamento  - alterarFormaPagamento',
				tags: {
					endpoint: 'financeiro/financeiro_alterar_forma_pagamento',
					file: 'src/store/sagas/financial.ts' 
				},
				payload: payload
			})
			
			throw e;
		}
	}

	try {
		const data = yield call(apiCall);
		if (
			data.status === TypesErrorRequest.SUCCESS
			&& data?.faturas?.[data?.faturas?.length -1]?.codigo
			&& data?.faturas?.[data?.faturas?.length -1]?.invoice
			&& data?.faturas?.[data?.faturas?.length -1]?.urlcodigobarras
		) {
			yield put(FinancialActions.set_load_card(false));
			yield put(FinancialActions.set_modal_falha_pagamento(false, null));
			yield put(FinancialActions.set_load_change_payment_method(false))

			if(modalSelectFormPayment){
				yield put(FinancialActions.set_modal_escolha_pagamento(false))
			}
			if(
				payment_type === 'pix' 
				&& !modaErrorPixVisible 
			){
				yield put(FinancialActions.set_modal_pix(true, data?.faturas))
			}
			if(payment_type === 'bank_slip' && !modaErrorPixVisible	){
				yield put(FinancialActions.set_modal_boleto(true, data?.faturas))
			}
			if(payment_type === 'card'){
				yield put(FinancialActions.set_request_pay_envoice())
			}
			if(payment_type === 'bank_slip'  &&  modaErrorPixVisible){
				window.open(data?.faturas?.[data?.faturas?.length -1]?.pdf, "_blank")
			}


		
		} else {
			yield put(FinancialActions.set_modal_escolha_pagamento(false))
			yield put(FinancialActions.set_load_card(false));
			yield put(FinancialActions.set_load_change_payment_method(false))
			if(payment_type === 'pix'){
				yield put(FinancialActions.modal_error_pix_data(true))
				yield put(FinancialActions.set_modal_falha_pagamento(false, null))
			}
			if(payment_type === 'bank_slip' && !modaErrorPixVisible ){
				yield put(AppActions.showSnackbar(
						current_language?.erro_alterar_forma_pagamento || "Erro ao alterar forma de pagamento",
						"error"
					)
				);
				yield put(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo?.toString()))
			}
			if(payment_type === 'bank_slip' && modaErrorPixVisible ){
				yield put(AppActions.showSnackbar(
						current_language?.erro_alterar_forma_pagamento || "Erro ao alterar forma de pagamento",
						"error"
					)
				);
				yield put(FinancialActions.set_modal_falha_pagamento(true, inadimplencia_motivo?.toString()))
				yield put(FinancialActions.modal_error_pix_data(false) )
			}

		}
	} catch (e) {
		yield put(
			AppActions.showSnackbar(
				current_language?.erro_alterar_forma_pagamento || "Erro ao alterar forma de pagamento",
				"error"
			)
		);
	}
}

function* payEnvoice(){
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const connect:boolean = yield select((state: any) => state.app.connect);
	const current_language: TextsProps = yield select(	(state) => state.configs.current_language);
	const faturas: FaturaProps[] = yield select((state: any) => state.financial.faturas);
	const dataFaturaAtual: FaturaProps = yield select(	(state: any) => state.financial.modal_pagamento_cartao_data);
	const config_servicos:{SERVICO_IUGU: string | number;	SERVICO_SUPERLOGICA: string | number} = yield select((state: any) => state.configs.config_servicos);
	const type_client: 'bank_slip_pix' | 'card' | null = yield select((state: any) => state.financial.type_client);
		

	async function apiCall() {
		try {
			const dataRequest = {
				TOKEN: user_logado.token,
				ID_FATURA: dataFaturaAtual?.ID_FATURA 
					? String(dataFaturaAtual?.ID_FATURA) 
					: faturas.filter((fat)=>fat.FATURA_TIPO === 'PENDING')[faturas.filter((fat)=>fat.FATURA_TIPO === 'PENDING').length -1]?.ID_FATURA?.toString()
			};
			const requestOptions: any = {
				method: "POST",
				body: JSON.stringify(dataRequest),
			};
			// const res = await fetch(
			// 	`${process.env.REACT_APP_BASE_URL}/financeiro/financeiro_pagar_fatura.php`,
			// 	requestOptions
			// );
			// const response: any = await res.json();
			// return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao pagar fatura - payEnvoice',
				tags: {
					endpoint: '/financeiro/financeiro_pagar_fatura',
					file: 'src/store/sagas/financial.ts' 
				},
			})
			throw e;
		}
	}
	

	try{
		const data: {
			status: string,
			code: number,
			message: string
		} = yield call(apiCall);
		if(data.status == TypesErrorRequest.SUCCESS){
			yield put(FinancialActions.set_payment_executed(true))
			if(dataFaturaAtual?.ID_FATURA){
				yield put(FinancialActions.set_modal_pagamento_cartao(false, null));
			}
			yield put(FinancialActions.financial_request(
				config_servicos?.SERVICO_IUGU,
				config_servicos?.SERVICO_SUPERLOGICA
			));

			yield put(ConfigsActions.config_request())
			yield put(DashBoardActions.set_current_page("pagamentos"))
			
		}else{
			if(dataFaturaAtual?.ID_FATURA){
				yield put(FinancialActions.set_modal_pagamento_cartao(false, null))
			}
			yield put(FinancialActions.set_payment_error_with_card(true))
			yield put(FinancialActions.set_load_card(false))
			yield put(FinancialActions.set_modal_falha_pagamento(true, data?.code.toString()))

		}

	}catch(error){}
};

function* addUserWhitelist(
	payload: {
		payload:{
			days: number
		},
		type: string
	}
){

	
	const faturas: FaturaProps[] = yield select((state: any) => state.financial.faturas);
	const lastDataWhitelist: whiteListProps = yield select((state: any) => state.financial.last_data_white_list);
	const config_servicos:{SERVICO_IUGU: string | number,	SERVICO_SUPERLOGICA: string | number, SERVICO_HUB: string|number} = yield select((state: any) => state.configs.config_servicos);
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	
	const dataRequest = {
		TOKEN: user_logado.token,
		SERVICO_HUB: config_servicos?.SERVICO_HUB,
		DIAS_INFORMADOS: payload?.payload,
		ID_FATURA:  faturas.filter((fat)=>fat.FATURA_TIPO === 'PENDING')[faturas.filter((fat)=>fat.FATURA_TIPO === 'PENDING').length -1]?.ID_FATURA
	};
	
	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				body: JSON.stringify(dataRequest),
			};
			// const res = await fetch(
			// 	`${process.env.REACT_APP_BASE_URL}/financeiro/financeiro_adicionar_whitelist.php`,
			// 	requestOptions
			// );
			// const response: any = await res.json();
			// return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao adicionar usuario na white list - addUserWhiteList',
				tags: {
					endpoint: '/financeiro/financeiro_adicionar_whitelist',
					file: 'src/store/sagas/financial.ts' 
				},
			})
			throw e;
		}
	}
	

	try{
		const  data: {
			status: string,
			code: number,
			message: string
		}  = yield call(apiCall);

		if(data?.status === TypesErrorRequest.SUCCESS){
			
			yield put(FinancialActions.set_modal_boleto(false))
			yield put(FinancialActions.set_modal_pagamento_processado(true, 'userInWhitList'))

			yield put(ConfigsActions.config_request())

		}else{
			yield put(
				AppActions.showSnackbar(
					data?.message,
					"error"
				)
			);
		}

	}catch(error){}

}


export function* FianncialSaga(): any {
	return yield all([
		takeLatest(Types.FATURAS_REQUEST, getFaturas),
		takeLatest(Types.ADD_CARD_REQUEST, addCard),
		takeLatest(Types.PLANOS_ITENS, getPlanosItens),
		takeLatest(Types.ASSINAR_PLANO, assinarPlano),
		takeLatest(Types.ASSINAR_ITEM, assinarItem),
		takeLatest(Types.ALTERAR_FORMA_PAGAMENTO_REQUEST, alterarFormaPagamento),
		takeLatest(Types.REQUEST_PAY_ENVOICE, payEnvoice),
		takeLatest(Types.REQUEST_ADD_USER_IN_WHITE_LIST, addUserWhitelist),
	]);
}
